import { GQLAddress } from '@jewelutions/core-crm-server-api-client-domain';

export class GQLAddressHelper {
  static addressToString(address: GQLAddress) {
    return `${address.country}, ${address.city}, ${address.street} ${address.streetNumber}`;
  }
}
